import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'

import { UpdateOperatorForm } from '@/components/pages/Operator/Update'
import { UpdateOperatorFormValue } from '@/components/pages/Operator/Update/Form'
import UpdateOperatorPageHeader from '@/components/pages/Operator/Update/PageHeader'
import { Customer } from '@/types'

import { useOperators } from '../Operator.hooks'
import { useGetOperator, useUpdateOperators } from './update.hooks'

const UpdateOperator = () => {
  const params = useParams<{ id: string }>()
  const { updateOperator, loading: updateLoading } = useUpdateOperators()
  const { getOperator, loading: getLoading, response: getOperatorResponse } = useGetOperator()
  const { deleteOperator } = useOperators()

  const operatorId = Number(params.id)

  const handleDeleteOperator = async (id: Customer['id']) => {
    await deleteOperator({ id })
  }

  const handleSubmitForm = async (formValues: UpdateOperatorFormValue) => {
    await updateOperator({
      ...formValues,
      id: operatorId,
    })
  }

  useEffect(() => {
    getOperator({ id: operatorId }).then()
  }, [operatorId, getOperator, params.id])

  return (
    <>
      <UpdateOperatorPageHeader />
      <UpdateOperatorForm
        {...{ updateLoading, getLoading, getOperatorResponse, operatorId }}
        onSubmit={handleSubmitForm}
        onDelete={handleDeleteOperator}
      />
    </>
  )
}

UpdateOperator.displayName = 'UpdateOperator'
export default UpdateOperator
